const ETH_STARKNET_ADDRESS = '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7';
const DEFAULT_STARKNET_TYPED_DATA_DOMAIN = {
    domain: {
        name: 'Dynamic Sample dApp',
        version: '0.0.1',
    },
};

export { DEFAULT_STARKNET_TYPED_DATA_DOMAIN, ETH_STARKNET_ADDRESS };
